// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__Lwvxh","title":"card_title__llES3","subtitle":"card_subtitle__dwFcP","close":"card_close__5pup5","textButton":"card_textButton__37I7_","body":"card_body__BFaI8"};